"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.imgMoveReducer = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("../../../utils");
/**
 * @description
 * 画像をズームして動かした場合のx, y方向（右・下が正）の変化量を返す．

 *
 * 《op === 'drag'の場合の動作》
 * マウスのドラッグによる微小変化量を単に足すだけ．
 *
 * 《op === 'zoom'の場合の動作》
 * マウスホイールによる拡大率の変化率r（1.01や0.99などの値）に応じて，
 * マウスポインタの位置(px, py)を中心に（＝画像上の位置を動かさずに）ズームする．
 *
 * x_currを画像の移動量（初期値0，右が正），x_nextを更新後の移動量として，
 *
 * (|x_next| + px) = r(|x_curr| + px)
 * <=> (-x_next + px) = r(-x_curr + px)
 *
 * となればよいので，
 *
 * x_next = -(r * (-x_curr + px) - px)
 *        = -(r * (-x_curr) + r * px - px)
 *        = -(r * (-x_curr) + px * (r - 1))
 *        = r * x_curr - px * (r - 1)
 * と更新すればよい．（yも同様）
 *
 *     virtualImgRectAbsolute (next)
 *   +--------------------------------------------------------------+ .... ^
 *   |                                                              |      |
 *   |                                                              |      |
 *   |                                                              |      |
 *   |                            virtualImgRectAbsolute (curr)     |      |  |y_next|
 *   |          +----------------------------------------------+    |      |
 *   |          |                ^                             |    |      |
 *   |          |       |y_curr| |                             |    |      |
 *   |          |                |    visible area             |    |      |
 *   |          |           +----------------------+           |    | .... v
 *   |          |           |                      |           |    |      ^
 *   |          |<----------|                      |           |    |      |
 *   |          | |x_curr|  |                      |           |    |      |
 *   |          |           |                      |           |    |      |
 *   |          |           |                      |           |    |      |
 *   |          |           |            (px, py)  |           |    |      | py
 *   |          |           |                  +   |           |    |      |
 *   |          |           |                      |           |    |      |
 *   |          |           +----------------------+           |    | .... v
 *   |          |                                              |    |
 *   |          |                                              |    |
 *   |          |                                              |    |
 *   |          |                                              |    |
 *   |          +----------------------------------------------+    |
 *   |                                                              |
 *   +--------------------------------------------------------------+
 *   :                      :                  :
 *   :                      :                  :
 *   <----------------------><----------------->
 *          |x_next|                 px
 *
 *
 *
 * 《clampXYの動作》
 * clampは値を範囲内に収める関数（例： `clamp(0, 2)(2.3) // 2`）
 * Z が V の端を超えないように（全体を含むように）する．
 *
 *     virtualImgRectAbsolute (=Z)
 *   +---------------------------------+
 *   |           ^                     |
 *   |        -y |                     |
 *   |      +------------------+       |
 *   |<-----|                  |       |
 *   |  -x  |  visible area    |       |
 *   |      |      (=V)        |       |
 *   |      +------------------+       |
 *   |                                 |
 *   +---------------------------------+
 *
 *  -((Z.width) - (V.width)) <= x <= 0
 *  <=> -((zoom ratio) - 1) * (V.width) <= x <= 0
 *
 */
var imgMoveReducer = function (acc, _a) {
    var _b = tslib_1.__read(_a, 2), v = _b[0], _c = tslib_1.__read(_b[1], 2), pointerPos = _c[0], zoomRatio = _c[1];
    var clampXY = (0, utils_1.clamp)(-(zoomRatio - 1), 0);
    switch (v.op) {
        case 'reset':
            return acc.withMutations(function (prev) { return prev.set('x', 0).set('y', 0); });
        case 'drag': {
            // `delta` is drag amount delta
            return acc.withMutations(function (prev) {
                return prev
                    .update('x', function (x) { return x + v.delta.x; })
                    .update('y', function (y) { return y + v.delta.y; })
                    .update('x', clampXY)
                    .update('y', clampXY);
            });
        }
        case 'zoom': {
            // `delta` is zoom ratio delta
            var _d = pointerPos !== null && pointerPos !== void 0 ? pointerPos : (0, utils_1.IPos)({ x: 0.5, y: 0.5 }), px_1 = _d.x, py_1 = _d.y;
            var zoomRatioDelta_1 = v.delta;
            return acc.withMutations(function (prev) {
                return prev
                    // x_next = r * x_curr - px * (r - 1)
                    // y_next = r * y_curr - py * (r - 1)
                    .update('x', function (x) { return zoomRatioDelta_1 * x - px_1 * (zoomRatioDelta_1 - 1); })
                    .update('y', function (y) { return zoomRatioDelta_1 * y - py_1 * (zoomRatioDelta_1 - 1); })
                    .update('x', clampXY)
                    .update('y', clampXY);
            });
        }
    }
};
exports.imgMoveReducer = imgMoveReducer;
